import { Gym } from "@api/types";
import { ChatAltIcon } from "@heroicons/react/outline";
import { PlusIcon } from "@heroicons/react/solid";
import { MessagesLayout } from "@modules/message";
import { Sidebar, SidebarProps } from "@modules/message/sidebar";
import EmptyState from "@ui/components/empty-state";
import { noop } from "lodash";
import Link from "next/link";
import { useRouter } from "next/router";
import { buttonVariants } from "@/components/ui/button";

type MessageIndexProps = {
  gym: Gym;
  sidebarProps: SidebarProps;
};
function MessagesIndex(props: MessageIndexProps) {
  const router = useRouter();
  const { threads, tabs, currentTab, search } = props.sidebarProps;

  if (!props.gym.phoneNumber) {
    router.push("/messages/phone-number");
    return null;
  }

  return (
    <>
      <div className="lg:hidden flex min-h-0 flex-1 flex-col overflow-hidden">
        <Sidebar
          tabs={tabs}
          currentTab={currentTab}
          search={search}
          threads={threads}
          onInfiniteScroll={noop}
        />
      </div>
      <div className="top-1/3 lg:block absolute hidden w-full">
        <EmptyState
          title="Start messaging"
          description="Select a conversation or start a new one."
          icon={ChatAltIcon}
          action={
            <div className="max-w-[160px] m-auto">
              <Link
                href="/messages/new"
                className={buttonVariants({ variant: "outline", className: "w-full" })}
              >
                <PlusIcon className="w-4 h-4 mr-2 -ml-1" aria-hidden="true" />
                New message
              </Link>
            </div>
          }
        />
      </div>
    </>
  );
}

export default function MessagesIndexContainer() {
  return <MessagesLayout>{(props) => <MessagesIndex {...props} />}</MessagesLayout>;
}
